import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DataService } from 'src/app/Service/data.service';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { FilterGroup, FilterPanelComponent, FilterPanelOptions } from './components/filter-panel/filter-panel.component';
import { PushModalComponent } from './components/push-modal/push-modal.component';
import { SmsModalComponent } from './components/sms-modal/sms-modal.component';
import { ValidityModalComponent } from './components/validity-modal/validity-modal.component';
import { AssignModalComponent } from './components/assign-modal/assign-modal.component';
import axios from 'src/app/Service/axios';
import * as XLSX from 'xlsx';
declare let $: any;

@Component({
  selector: 'carList',
  templateUrl: './car_list.Component.html',
  styleUrls: ['./car_list.Component.css'],
})
export class CarListComponent implements OnInit {
  excelFileName = 'لیست متحرک‌ها.xlsx';

  cars: any;
  visibleCars: any = [];
  carCount = 0;

  isDesktop: any;
  allSelected = false;

  canEditCars = false;
  isSimpleUser = false;
  canSendSms = false;
  canSendPush = false;
  canSendPayamak = false;
  canUpdateValidity = false;
  isTaxiLon = false;

  systemUserId = this.gurdService.decrypt(localStorage.getItem('ID')!);
  sessionId = this.gurdService.decrypt(localStorage.getItem('Session')!);

  isFilterPanelOpen = true;
  filterOptions: FilterPanelOptions = {
    usageTypes: [],
    vehicleGroups: [],
    vehicleTypes: [],
    vehicleBrands: [],
    trackerTypes: [],
    serviceAreas: [],
    plateTypes: [],
  };
  appliedFilterValue: any = null;

  activeFilterCount = 0;
  filterGroupCounts: Record<FilterGroup, number> = {
    cat: 0,
    spec: 0,
    driver: 0,
    time: 0,
  };

  private readonly filterGroupKeys: Record<FilterGroup, string[]> = {
    cat: [
      'tiMobileUsage',
      'tiMobileGroup',
      'tiMobileType',
      'tiGPSType',
      'iGPS',
      'iMobileDomain',
    ],
    spec: [
      'tiFuelType',
      'tiPlateType',
      'tiPassenger',
      'strVehicleType',
      'iSKm',
      'iEKm',
      'iSYearConstruction',
      'iEYearConstruction',
    ],
    driver: [
      'strFullName',
      'strMobile',
      'strCellNo',
      'strUnitID',
      'strVehicleNo',
      'strPersonnelID',
    ],
    time: ['strSTime', 'strETime'],
  };

  private readonly quickSearchKeys = [
    'strFullName2',
    'strUnitID',
    'strVehicleNo',
    'strMobileDomain_strComment',
    'strCellNo',
    'strPersonnelID',
    'strMobile',
  ];

  quickSearchForm = new FormGroup({
    txt: new FormControl(),
  });

  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;
  @ViewChild(FilterPanelComponent, { static: false }) filterPanel!: FilterPanelComponent;
  @ViewChild(PushModalComponent, { static: false }) pushModal!: PushModalComponent;
  @ViewChild(SmsModalComponent, { static: false }) smsModal!: SmsModalComponent;
  @ViewChild(ValidityModalComponent, { static: false }) validityModal!: ValidityModalComponent;
  @ViewChild(AssignModalComponent, { static: false }) assignModal!: AssignModalComponent;

  constructor(
    private notify: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
    private deviceService: DeviceDetectorService,
    private dataService: DataService,
    public otherService: OtherService,
    public gurdService: GurdServiceService,
  ) {}

  ngOnInit(): void {
    this.readMenuPermissions();

    if (Number(this.systemUserId) === -2) {
      this.isSimpleUser = true;
      this.isFilterPanelOpen = false;
      this.loadCars();
    } else {
      this.loadFilterOptions();
    }

    this.route.url.subscribe((segment) => {
      if (segment[0]?.path == 'manage-drivers') this.isTaxiLon = true;
    });

    this.quickSearchForm.controls['txt'].setValue(
      this.dataService.carListTxtSearch,
    );
    if (this.dataService.carListTxtSearch) this.quickSearch();

    this.isDesktop = this.deviceService.isDesktop();
  }

  private readMenuPermissions(): void {
    const menu = JSON.parse(
      this.gurdService.decrypt(localStorage.getItem('menu') as any),
    );
    this.canEditCars = menu.bEnableEditCar;
    this.canSendSms = menu.bSendSMS2MobilesUser;
    this.canSendPush = menu.bSendPush2MobilesUser;
    this.canSendPayamak = menu.bSendSMS2Driver;
    this.canUpdateValidity = menu.bFleetyar_UpdateValidDate;
  }

  private get sessionModel(): { strSession: string; iSystemUser: string } {
    return {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
    };
  }

  private handleSessionExpiry(errorCode: string): void {
    this.otherService.removeLocalStorage();
    this.router.navigate(['login'], { queryParams: { error: errorCode } });
  }

  private setCars(list: any[]): void {
    this.cars = list ?? [];
    this.visibleCars = this.cars;
    this.carCount = this.cars.length;
    this.scrollTableToEnd();
  }

  private scrollTableToEnd(): void {
    setTimeout(() => {
      const el = this.scrollContainer?.nativeElement;
      if (el) el.scrollLeft = el.scrollWidth;
    }, 10);
  }

  private getSelectedUnitIds(): string[] {
    return (this.visibleCars ?? [])
      .filter((c: any) => c?.bChosen)
      .map((c: any) => c.strUnitID);
  }

  private requireSelection(): string[] | null {
    if (!this.visibleCars?.length) {
      this.notify.showError('خودرویی موجود نیست!');
      return null;
    }
    const ids = this.getSelectedUnitIds();
    if (!ids.length) {
      this.notify.showError('لیست انتخابی شما خالی می باشد');
      return null;
    }
    return ids;
  }

  toggleFilterPanel(): void {
    if (this.isFilterPanelOpen) this.filterPanel?.requestClose();
    else this.isFilterPanelOpen = true;
  }

  openFilterPanel(): void {
    this.isFilterPanelOpen = true;
  }

  onFilterClosed(): void {
    this.isFilterPanelOpen = false;
  }

  private isFilterValueActive(val: any): boolean {
    if (val === null || val === undefined) return false;
    if (typeof val === 'string' && val.trim() === '') return false;
    if (String(val) === '-1') return false;
    return true;
  }

  updateActiveFilterCount(values: any): void {
    let total = 0;
    (Object.keys(this.filterGroupKeys) as FilterGroup[]).forEach((group) => {
      let count = 0;
      this.filterGroupKeys[group].forEach((key) => {
        if (this.isFilterValueActive(values?.[key])) count++;
      });
      this.filterGroupCounts[group] = count;
      total += count;
    });
    this.activeFilterCount = total;
  }

  async loadCars(): Promise<void> {
    this.otherService.Showspinner();
    if (!this.dataService.carList_New) {
      await this.dataService.getCarList_New();
    }
    this.setCars(this.dataService.carList_New);
    this.otherService.nonespinner();
  }

  async updateServiceArea(): Promise<void> {
    const unitIds = this.requireSelection();
    if (!unitIds) return;

    this.otherService.Showspinner();
    const resp = await axios.post(
      `MobileDomain_ListUserAccess`,
      this.sessionModel,
    );
    if (resp.data.ISSessionExpired == true) {
      this.handleSessionExpiry('13');
      return;
    }
    this.otherService.nonespinner();

    const areas: any[] = JSON.parse(resp.data);
    const withHeader = (list: any[]) => [
      { iMobileDomain: -1, strComment: 'انتخاب کنید' },
      ...list,
    ];
    const selectEl = $('<select class="form-control" id="mySelect"></select>');
    const renderOptions = (list: any[]) =>
      selectEl.html(
        list
          .map(
            (a: any) =>
              `<option value="${a.iMobileDomain}">${a.strComment}</option>`,
          )
          .join(''),
      );
    renderOptions(withHeader(areas));

    const searchInput = $(
      '<input class="form-control mb-2" placeholder="نام حوزه خدمت را جستجو کنید" id="myInput">',
    );

    $.confirm({
      title: ``,
      content: searchInput.add(selectEl),
      type: 'blue',
      buttons: {
        ok: {
          text: 'ثبت',
          btnClass: 'btn-primary',
          keys: ['enter'],
          action: async () => {
            const selectedValue = $('#mySelect').val();
            if (selectedValue == '-1') {
              return this.notify.showError('لطفا نام حوزه را مشخص کنید !!');
            }
            this.otherService.Showspinner();
            const res = JSON.parse(
              (
                await axios.post(`Mobiles_UpdateMobileDomain`, {
                  ...this.sessionModel,
                  lstUnitID: unitIds,
                  iMobileDomain: selectedValue,
                })
              ).data.toString(),
            );
            this.otherService.nonespinner();

            if (res.ISSessionExpired == true) {
              this.handleSessionExpiry('14');
              return;
            }
            if (res.iResult == 0) return this.notify.showError(res.strError);

            const first = !res.length ? res : res[0];
            if (first.iResult == 0)
              return this.notify.showError(first.strError);

            await this.dataService.getCarList().then(() => {
              this.setCars(this.dataService.carList);
            });
            return this.notify.showSuccess('با موفقیت ویرایش شد');
          },
        },
        cancel: {
          text: 'لغو',
        },
      },
    });

    searchInput.on('input', () => {
      const keyword = searchInput.val().toString().trim().toLowerCase();
      renderOptions(
        withHeader(
          areas.filter((a: any) => a.strComment.trim().includes(keyword)),
        ),
      );
    });
  }

  async onFilterApply(value: any): Promise<void> {
    this.otherService.Showspinner();

    const model = this.otherService.stringNumberToNumber(value);
    const resp: any = await axios.post(`FleetYar_Car_Search`, model);
    this.otherService.nonespinner();

    const res = JSON.parse(resp.data.toString());

    if (res.ISSessionExpired == true) {
      this.notify.showError('لطفا وارد سیستم شوید');
      this.handleSessionExpiry('15');
      return;
    }

    if (res.iResult == 0) return this.notify.showError(res.strError);

    this.setCars(res);

    // بج تعداد فیلترها فقط با «اعمال فیلتر» موفق به‌روز می‌شود
    this.updateActiveFilterCount(value);
    this.appliedFilterValue = { ...value };
    this.isFilterPanelOpen = false;
  }

  async loadFilterOptions(): Promise<void> {
    this.otherService.Showspinner();

    const domainRes = JSON.parse(
      (
        await axios.post(
          `GetMobileDomain4Report?iSystemUser=${this.systemUserId}`,
          {},
        )
      ).data,
    );
    if (domainRes.bError) {
      this.otherService.nonespinner();
      return this.notify.showError(domainRes.strError);
    }

    const vehicleTypes = (await axios.post(`GetMobileType`)).data;
    const vehicleBrands = (await axios.post(`GetGPSType`)).data;

    const trackers = (await axios.post(`GetGPS`)).data || [];
    const trackerTypes = [
      { iGPS: -1, strComment: '— همه —' },
      ...trackers.map((t: any) => ({ ...t, iGPS: Number(t.iGPS) })),
    ];

    const usageTypes = JSON.parse((await axios.post(`MobileUsage_List`)).data);
    const plateTypes = JSON.parse((await axios.post(`PlateType_List`)).data);
    const vehicleGroups = JSON.parse((await axios.post(`GetMobileGroup`)).data);

    this.filterOptions = {
      usageTypes,
      vehicleGroups,
      vehicleTypes,
      vehicleBrands,
      trackerTypes,
      serviceAreas: domainRes,
      plateTypes,
    };

    this.otherService.nonespinner();
  }

  openSmsModal(): void {
    const unitIds = this.requireSelection();
    if (!unitIds) return;
    this.smsModal?.open(unitIds);
  }

  quickSearch(): void {
    const query = String(this.quickSearchForm.value.txt ?? '');
    this.dataService.carListTxtSearch = this.quickSearchForm.value.txt;
    this.visibleCars = (this.cars ?? []).filter((car: any) =>
      this.quickSearchKeys.some((key) =>
        String(car?.[key] ?? '').includes(query),
      ),
    );
    this.carCount = this.visibleCars.length;
    this.scrollTableToEnd();
  }

  sortBy(column: number): void {
    const rows = this.visibleCars;
    if (!rows?.length) return;

    rows.sort((a: any, b: any) => {
      switch (column) {
        case 0:
          return (
            (b.strPersonnelID ?? Infinity) - (a.strPersonnelID ?? Infinity)
          );
        case 2:
          return (
            +new Date(a.strDefinationDate) - +new Date(b.strDefinationDate)
          );
        case 3:
          return +new Date(a.strValidDate) - +new Date(b.strValidDate);
        default: {
          const cellOf = (car: any) =>
            column === 1
              ? car.strFullName?.toUpperCase()
              : column === 4
                ? car.strMobileDomain_strComment?.toUpperCase()
                : (car.strDate + car.strTime).toUpperCase();
          const textA = cellOf(a);
          const textB = cellOf(b);
          return textA > textB ? -1 : textA < textB ? 1 : 0;
        }
      }
    });
  }

  exportExcel(tableId: string): void {
    if (!this.visibleCars?.length)
      return this.notify.showError('خودرویی موجود نیست!');

    const element = document.getElementById(tableId);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, this.excelFileName);
  }

  openCarDetails(car: any): void {
    window.open(`/carList/carInfo/${car.strUnitID}`, '_blank');
  }

  toggleSelectAllCars(): void {
    this.allSelected = !this.allSelected;
    this.visibleCars.forEach((car: any) => (car.bChosen = this.allSelected));
    if (this.allSelected)
      this.notify.showSuccess('همه خودروها با موفقیت انتخاب شدند');
  }

  onCarCheckbox(event: Event, index: number): void {
    event.stopPropagation();
    this.visibleCars[index].bChosen = (
      event.target as HTMLInputElement
    )?.checked;
  }

  showAllOnMap(): void {
    if (!this.visibleCars?.length)
      return this.notify.showError('خودرویی موجود نیست!');

    window.localStorage.setItem(
      'XmeTCrsX5GCZ',
      this.gurdService.encrypt(JSON.stringify(this.visibleCars)),
    );
    window.open('/carList-Tracker', '_blank');
  }

  openPushModal(): void {
    const unitIds = this.requireSelection();
    if (!unitIds) return;
    this.pushModal?.open(unitIds);
  }

  openDriverSchedule(event: Event, car: any): void {
    event.stopPropagation();
    this.assignModal?.open(car.strUnitID);
  }

  openValidityModal(): void {
    const unitIds = this.requireSelection();
    if (!unitIds) return;
    this.validityModal?.open(unitIds);
  }

}
